/*
 * File: components/admin/LeaveAdministration.js
 * Mô tả: Component container chính cho các chức năng quản lý phép.
 * CẬP NHẬT: Đọc tab từ URL và xóa thanh menu ngang.
 */
import React from 'react';
import { useLocation } from 'react-router-dom';
import LeaveManager from './LeaveManager';
import LeaveManagementComponent from './LeaveManagement';
import AdvancedSettings from './AdvancedSettings'; // Import component mới

export default function LeaveAdministration() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const activeTab = queryParams.get('tab') || 'manage';

    return (
        <div className="animate-fade-in">
            {activeTab === 'manage' && <LeaveManager />}
            {activeTab === 'config' && <LeaveManagementComponent />}
            {activeTab === 'advanced' && <AdvancedSettings />}
        </div>
    );
}